export const heroSlides = [
  {
    badge: '新人限定',
    title: '新用户首单优惠',
    subtitle: '首次下单分享专属优惠，最高可抵扣 ¥200',
    amount: '200',
    cta: '下载 App 领取',
  },
  {
    badge: '限时活动',
    title: '名师一对一辅导',
    subtitle: '预约专属导师，量身定制留学规划方案',
    amount: '500',
    cta: '立即预约',
  },
  {
    badge: '热门推荐',
    title: '考学资料免费领',
    subtitle: '注册即送日本留学考学全套资料包',
    amount: '0',
    cta: '免费领取',
  },
]

export const courses = [
  {
    id: 1,
    category: '理工',
    title: '空间情报 · 研究计划书',
    price: 4000,
    tags: ['研究计划书', '包含套磁指导', '¥100/h'],
    description:
      '本课程针对日本大学院理工类空间情报方向，涵盖研究计划书撰写、套磁信指导及面试模拟，适合目标东京大学、京都大学等名校的同学。',
    teacher: {
      name: '张三老师',
      avatar: '',
      info: '东京大学 · 空间情报 · 博士后',
    },
  },
  {
    id: 2,
    category: '文科',
    title: '社会学 · 小论文指导',
    price: 3500,
    tags: ['小论文', '文献检索', '¥90/h'],
    description:
      '专注日本社会学方向考学辅导，从选题、文献综述到论文撰写全程指导，帮助同学高效完成出愿材料。',
    teacher: {
      name: '李四老师',
      avatar: '',
      info: '一桥大学 · 社会学 · 博士',
    },
  },
  {
    id: 3,
    category: '商科',
    title: '经营学 · 面试特训',
    price: 2800,
    tags: ['面试指导', '案例分析', '¥80/h'],
    description:
      '针对日本MBA及经营学研究科面试，提供模拟面试、案例分析与个人陈述修改，提升合格概率。',
    teacher: {
      name: '王五老师',
      avatar: '',
      info: '早稻田大学 · 经营学 · 硕士',
    },
  },
]

export const teachers = [
  {
    id: 1,
    name: '张三老师',
    verified: true,
    avatar: '',
    bio: '东京大学空间情报学博士后，5年日本留学辅导经验，擅长研究计划书撰写与套磁指导，已帮助50+同学成功考入东大、京大等顶尖院校。',
    tags: ['东京大学', '博士后', '空间/建筑'],
  },
  {
    id: 2,
    name: '李四老师',
    verified: true,
    avatar: '',
    bio: '一桥大学社会学博士，专注文科类考学辅导，熟悉各大学社会学研究科招生特点，提供从选校到出愿的一站式服务。',
    tags: ['一桥大学', '博士', '社会学'],
  },
  {
    id: 3,
    name: '王五老师',
    verified: true,
    avatar: '',
    bio: '早稻田大学经营学硕士，曾任职于知名咨询公司，擅长商科面试辅导与职业规划，帮助同学展现最佳面试状态。',
    tags: ['早稻田大学', '硕士', '经营学'],
  },
]

export const articles = [
  {
    id: 1,
    title: '2025年日本留学签证政策最新解读',
    excerpt:
      '日本入管局近日发布了2025年度留学签证新政策，本文将详细解读材料要求、审核周期及注意事项，帮助同学们顺利办理签证。',
    hashtags: ['#签证政策', '#最新资讯'],
  },
  {
    id: 2,
    title: '东京大学大学院出愿时间一览',
    excerpt:
      '整理了东京大学各研究科2025年度夏季与冬季入试的出愿时间节点，包括网上出愿、材料邮寄及考试日期等重要信息。',
    hashtags: ['#东大', '#出愿日程'],
  },
  {
    id: 3,
    title: '研究计划书写作五大常见误区',
    excerpt:
      '研究计划书是考学的核心材料，本文总结了同学们在撰写过程中最常犯的五个错误，并提供相应的修改建议与优秀范例。',
    hashtags: ['#研究计划书', '#考学技巧'],
  },
]
